import LandingPage from '@/components/shadowban/landing-page';
import TopSearch from '@/components/shadowban/TopSearch';
import React, { useState } from 'react';
import { message } from 'antd';
import { useTranslation } from 'next-i18next';
import Searching from '@/components/shadowban/searching';
import SearchResult from '@/components/shadowban/search-result';
import CommonSimpleModal from '@/components/Common/CommonSimpleModal';
import { getShadowban } from '@/lib/service/shadowban';
import DownloadStoriesBottomContent from '@/components/shadowban/DownloadStoriesBottomContent';

export default function ShadowbanPageClient({ data }: { data: any }) {
  const { t } = useTranslation();
  const { contentData = {} } = data;
  const {
    contentInfo: { 'section-buttom': sectionButtom },
  } = contentData;
  const inputValueControl = useState('');
  const [loading, setLoading] = useState(false);
  const [simpleModalShow, setSimpleModalShow] = React.useState(false);
  const [result, setResult] = React.useState<any>(null);

  function handleSearch(text: string) {
    if (loading) return;
    if (!text.trim()) {
      message.warning(t('Please enter a username or profile link'));
      return;
    }

    setLoading(true);
    getShadowban(text, { isPremium: false, bizFuncName: 'shadowban' })
      .then((res) => {
        if (res?.code || !res?.data) throw res;
        setResult(res.data);
      })
      .catch(() => {
        setResult(null);
        setSimpleModalShow(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  return (
    <div className="bg-white">
      <LandingPage data={contentData}>
        <TopSearch onSearchClick={handleSearch} inputValueControl={inputValueControl} loading={loading} />
        {loading && <Searching />}
        {result && <SearchResult data={result} />}
      </LandingPage>
      <CommonSimpleModal
        open={simpleModalShow}
        title={t('Invalid Instagram Username')}
        desc={t(
          'We can’t access this account. Please check if the username is correct, or if the account is set to private.'
        )}
        btnTitle={t('TRYAGAIN')}
        closeAction={() => setSimpleModalShow(false)}
      />
      <DownloadStoriesBottomContent
        bottomInfo={sectionButtom}
        inputValueControl={inputValueControl}
        loading={loading}
        onSearchClick={handleSearch}
      />
    </div>
  );
}
